module.exports = __webpack_public_path__ + "static/media/facebook.cc663fe8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook.svg
// module id = 1992
// module chunks = 0